import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, Form, InputNumber, Select, Input, Row, Col, Space, } from "antd";
import { addResult, getBelts, getClasses, } from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import callApi from "../../constants/API/CallApi";
import { Severty, ShowToast } from "../../helper/toast";
import { useNavigate, useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import lang from "../../helper/langHelper";
import CustomTable from "../../components/CustomTable";
import { AppStateContext } from "../../context/AppContext";
import useRequest from "../../hooks/useRequest";
import { useLocation } from "react-router-dom";

const ExamView = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Eligible Student Management");
  const { id } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [student, setStudent] = useState();
  const [graduationModal, setGraduationModal] = useState(false);
  const [belts, setBelts] = useState([]);
  const [classes, setClasses] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const { request } = useRequest();
  const [search, setSearch] = useState("");
  const [classId, setClassId] = useState(null);
  const [beltId, setBeltId] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const branchId = queryParams.get("branchId");

  const columns = [
    { title: lang("Student"), dataIndex: "name", key: "student" },
    { title: lang("Parent"), dataIndex: ["parent", "name"], key: "parent" },
    { title: lang("Belt"), dataIndex: ["belt", "name"], key: "belt" },
    {
      title: lang("Phone"),
      key: "phone",
      render: (_, record) => {
        const phone = record.parent?.mobileNumber;
        const code = record.parent?.countryCode;
        return phone ? `+${code}${phone}` : "-";
      },
    },
    {
      title: lang("Attended"),
      dataIndex: "totalAttendance",
      key: "totalAttendance",
    },
    {
      title: lang("Required"),
      key: "requiredClasses",
      render: (_, record) => {
        return record.totalRequiredClasses ?? "-";
      },
    },
    {
      title: lang("Earned Kyus"),
      dataIndex: "earnedKyus",
      key: "earnedKyus",
      render: (text, record) => {
        return record?.earnedKyus?.map((r, i) => <div key={i}>{r?.name}</div>);
      },
    },
    {
      title: lang("Actions"),
      key: "actions",
      render: (_, rec) => (
        <div className="d-flex align-items-center gap-2">
          <Button
            className="m-0"
            onClick={() => {
              setGraduationModal(true);
              setStudent(rec?.studentId);
            }}
          >
            {lang("Score")}
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useApi({
    callback: getBelts,
    payload: branchId ? { branchId } : null,
    dependencies: [branchId],
    shouldCallApi: !!branchId,
    onSuccess: ({ data }) => {
      setBelts(data || []);
    },
  });

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const getEligibleStudents = () => {
    setLoading(true);

    request({
      url: `admin/exam/eligibles/${id}?page=${page}&limit=${limit}&name=${debouncedSearch}${classId ? "&cls=" + classId : ""
        }${beltId ? "&belt=" + beltId : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setList(data?.data?.data || []);
        setTotalDocs(data?.data?.totalDocs || 0);
        setLoading(false);
      },
      onError: (error) => {
        ShowToast(error?.message, "error");
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    getEligibleStudents();
  }, [id, classId, beltId, search, page, limit, debouncedSearch]);

  const renderFilters = () => (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
      <div className="pageHeadingSearch">
        <Input.Search
          value={search}
          placeholder={"Search by Student Name"}
          className="searchInput"
          allowClear
          onChange={handleSearch}
        />
      </div>
      <Space>
        {/* <Select
          allowClear
          style={{ width: 200 }}
          placeholder="Filter by Class"
          onChange={(val) => setClassId(val)}
          value={classId}
          options={classes?.map((cls) => ({
            label: cls.name,
            value: cls._id,
          }))}
        /> */}
        <Select
          allowClear
          style={{ width: 200 }}
          placeholder="Filter by Belt"
          onChange={(val) => setBeltId(val)}
          value={beltId}
          options={belts?.map((belt) => ({
            label: belt.name,
            value: belt._id,
          }))}
        />
      </Space>
      <Button type="primary" onClick={handleExport}>
        Export Report
      </Button>
    </div>
  );

  const handleExport = () => {
    if (!list || list.length === 0) {
      ShowToast("No data available to export", Severty.WARNING);
      return;
    }

    const headers = [
      "Student",
      "Parent",
      "Phone",
      "Belt",
      "Attended Classes",
      "Required Classes",
      "Earned Kyus",
    ];

    const csvData = list.map((record) => [
      record.name || "-",
      record.parent?.name || "-",
      record.phone?.toString() || "-",
      record.belt?.name || "-",
      record.totalAttendance || "-",
      record.earnedKyus?.reduce((acc, cv) => acc + cv?.requiredClasses, 0) ||
      "-",
      record.earnedKyus?.length > 0
        ? record.earnedKyus?.map((kyu) => kyu?.name)?.join(", ")
        : "-",
    ]);

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "eligibles_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    ShowToast("Report exported successfully", Severty.SUCCESS);
  };

  return (
    <>
      <Button onClick={() => navigate(-1)} className="main-new-bacbuttonn">
        <ArrowLeftOutlined /> Back
      </Button>
      <CustomTable
        data={list}
        loading={loading}
        columns={columns}
        totalDocs={totalDocs}
        pagination={{
          current: page,
          pageSize: limit,
          total: totalDocs,
          showSizeChanger: true,
        }}
        onChange={(pagination) => {
          setPage(pagination.current);
          setLimit(pagination.pageSize);
        }}
        fields={{ range: false, search: false }}
        customFilter={renderFilters}
        hideAddButton
      />

      {graduationModal && (
        <GraduationModal
          refresh={() => setRefresh((x) => !x)}
          hide={() => setGraduationModal(false)}
          studentId={student}
          examId={id}
        />
      )}
    </>
  );
};

export default ExamView;

const GraduationModal = ({ refresh, hide, studentId, examId }) => {
  const [loading, setLoading] = useState(false);
  const [belts, setBelts] = useState([]);
  const [form] = Form.useForm();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const branchId = queryParams.get("branchId");

  const handleOk = async (values) => {
    setLoading(true);
    const payload = { ...values, studentId, examId };

    callApi({
      callback: addResult,
      payload,
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh((x) => !x);
        setLoading(false);
        hide();
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useApi({
    callback: getBelts,
    payload: branchId ? { branchId } : null,
    dependencies: [branchId],
    shouldCallApi: !!branchId,
    onSuccess: ({ data }) => {
      setBelts(data || []);
    },
  });

  return (
    <Modal
      title={"Submit Result"}
      open={true}
      className="tab_modal"
      width={800}
      onCancel={hide}
      footer={[
        <Button key="cancel" onClick={hide}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => form.submit()}
          loading={loading}
          form="examForm"
        >
          Submit
        </Button>,
      ]}
    >
      <Form form={form} id="examForm" layout="vertical" onFinish={handleOk}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item name="score" label="Score" rules={[{ required: true }]}>
              <InputNumber
                placeholder="Enter Student Exam Score"
                min={0}
                max={100}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="result"
              label="Result"
              rules={[{ required: true }]}
            >
              <Select placeholder="Select Result Status">
                <Select.Option value="passed">Passed</Select.Option>
                <Select.Option value="failed">Failed</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="nextBeltId"
              label="Next Belt"
              rules={[{ required: true, message: "Please select a belt" }]}
            >
              <Select placeholder="Select Belt">
                {Array.isArray(belts) &&
                  belts.map((belt) => (
                    <Select.Option key={belt._id} value={belt._id}>
                      {belt?.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={24}>
            <Form.Item name="remarks" label="Remarks">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
